import React from 'react';
import _ResponsiveImageCarousel from 'src/components/Modules/ResponsiveImageCarousel';

import { compose } from 'redux';
import { ContentModuleGroupPreloadingContext } from 'src/constrains/DraggableModules/PreloadComponent/SubscriptionPreloading';
import { errKeys } from 'src/constrains/DraggableModules/tools';
import { separateSymbol } from 'src/tools/constant';
import { EPreviewSize } from 'src/types/common/SalesChannel';
import ContentGroupHOC from '../HOC';

const ResponsiveImageCarousel = (props) => {
  const {
    staticData,
    dynamicData,
    handleOnItemDelete,
    handleItemOnAdd,
    handleItemOnChange,
    handleItemOnSort,
    handleOnStaticsChange,
    linkSet,
    specificError,
    droppableId,
    handleOnOpenNewTab,
    extraProps,
  } = props || {};
  const { breakpoint } = extraProps;
  const isConvertible = EPreviewSize.WIDE !== breakpoint;
  const { animations, hoverAnimations } = React.useContext(
    ContentModuleGroupPreloadingContext,
  );
  const layersKey = errKeys.ResponsiveImageCarousel.imageLayers;
  const layersError = Object.keys(specificError || {}).reduce((pre, key) => {
    // console.log('key', key);
    const isLayerError =
      key.startsWith(layersKey) && (specificError[key] || []).length > 0;
    if (isLayerError) {
      const id = key.split(separateSymbol)[1];
      return { ...pre, [id]: true };
    }
    return pre;
  }, {});
  //console.log('layersError', layersError);
  return (
    <_ResponsiveImageCarousel
      staticData={staticData}
      images={dynamicData}
      onItemDelete={handleOnItemDelete}
      onItemAdd={handleItemOnAdd}
      onItemChange={handleItemOnChange}
      onItemSort={handleItemOnSort}
      onStaticChange={handleOnStaticsChange}
      linkSet={linkSet}
      specificError={{ layers: layersError }}
      droppableId={droppableId}
      onOpenNewTab={handleOnOpenNewTab}
      animations={animations}
      hoverAnimations={hoverAnimations}
      isConvertible={isConvertible}
    />
  );
};
export default compose(ContentGroupHOC)(ResponsiveImageCarousel);
